/* eslint-disable no-nested-ternary */
const updatePagination = (slides, pagination) => {
  let previousSlideIndex = 0;

  slides.forEach((slide, index) => {
    if (slide.className.split(' ').includes('Gallery-slider-slides-slide-prev')) {
      previousSlideIndex = index;
    }
  });

  const bullets = pagination.querySelectorAll('.Gallery-slider-pagination-bullet');

  bullets.forEach((bullet) => bullet.classList.remove('Gallery-slider-pagination-bullet-active'));
  bullets[previousSlideIndex].classList.add('Gallery-slider-pagination-bullet-active');
};

const goToPage = (e, slides, pagination) => {
  const numberOfItems = slides.length;

  if (numberOfItems < 3) {
    return;
  }

  const page = Number(e.target.getAttribute('data-index'));

  slides.forEach((slide) => {
    slide.classList.remove('Gallery-slider-slides-slide-prev');
    slide.classList.remove('Gallery-slider-slides-slide-active');
    slide.classList.remove('Gallery-slider-slides-slide-next');
  });

  slides[page].classList.add('Gallery-slider-slides-slide-prev');
  slides[(page + 1) % numberOfItems].classList.add('Gallery-slider-slides-slide-active');
  slides[(page + 2) % numberOfItems].classList.add('Gallery-slider-slides-slide-next');

  updatePagination(slides, pagination);
};

const slideToRight = (slides, pagination) => {
  const numberOfItems = slides.length;
  let currentSlideIndex = 0;

  slides.forEach((slide, index) => {
    if (slide.className.split(' ').includes('Gallery-slider-slides-slide-active')) {
      currentSlideIndex = index;
    }
  });

  slides[(currentSlideIndex || numberOfItems) - 1].classList.remove('Gallery-slider-slides-slide-prev');

  slides[currentSlideIndex % numberOfItems].classList.remove('Gallery-slider-slides-slide-active');
  slides[currentSlideIndex % numberOfItems].classList.add('Gallery-slider-slides-slide-prev');

  slides[(currentSlideIndex + 1) % numberOfItems].classList.remove('Gallery-slider-slides-slide-next');
  slides[(currentSlideIndex + 1) % numberOfItems].classList.add('Gallery-slider-slides-slide-active');

  slides[(currentSlideIndex + 2) % numberOfItems].classList.add('Gallery-slider-slides-slide-next');

  updatePagination(slides, pagination);
};

const slideToLeft = (slides, pagination) => {
  const numberOfItems = slides.length;
  let currentSlideIndex = 0;

  slides.forEach((slide, index) => {
    if (slide.className.split(' ').includes('Gallery-slider-slides-slide-active')) {
      currentSlideIndex = index;
    }
  });

  slides[(currentSlideIndex - 1 >= 0 ? currentSlideIndex - 1 : numberOfItems - 1)]
    .classList.remove('Gallery-slider-slides-slide-prev');
  slides[(
    currentSlideIndex === 1
      ? (numberOfItems - 1)
      : (currentSlideIndex === 0 ? (numberOfItems - 2) : currentSlideIndex - 2)
  )].classList.add('Gallery-slider-slides-slide-prev');

  slides[currentSlideIndex].classList.remove('Gallery-slider-slides-slide-active');
  slides[(currentSlideIndex || numberOfItems) - 1].classList.add('Gallery-slider-slides-slide-active');

  slides[(currentSlideIndex + 1) % numberOfItems].classList.remove('Gallery-slider-slides-slide-next');
  slides[((currentSlideIndex + 1) || numberOfItems) - 1].classList.add('Gallery-slider-slides-slide-next');

  updatePagination(slides, pagination);
};

const loadSlider = () => {
  const sliders = document.querySelectorAll('.Gallery-slider');

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll('.Gallery-slider-slides-slide');
    const pagination = slider.querySelector('.Gallery-slider-pagination');

    slides.forEach((slide, index) => {
      const bullet = document.createElement('div');
      bullet.className = `Gallery-slider-pagination-bullet ${index === 0 ? 'Gallery-slider-pagination-bullet-active' : ''}`;
      bullet.setAttribute('data-index', index);
      bullet.addEventListener('click', (e) => goToPage(e, slides, pagination));

      pagination.appendChild(bullet);
    });

    if (slides.length === 1) {
      slides[0].classList.add('Gallery-slider-slides-slide-prev');
    }

    if (slides.length === 2) {
      slides[0].classList.add('Gallery-slider-slides-slide-prev');
      slides[1].classList.add('Gallery-slider-slides-slide-active');
    }

    if (slides.length > 2) {
      slides[0].classList.add('Gallery-slider-slides-slide-prev');
      slides[1].classList.add('Gallery-slider-slides-slide-active');
      slides[2].classList.add('Gallery-slider-slides-slide-next');

      const nextSlideButton = slider.querySelector('.Gallery-slider-button-next');
      const prevSlideButton = slider.querySelector('.Gallery-slider-button-prev');

      nextSlideButton.addEventListener('click', () => slideToRight(slides, pagination));
      prevSlideButton.addEventListener('click', () => slideToLeft(slides, pagination));
    }
  });
};

window.addEventListener('load', loadSlider);
